import styles from "./Modal.module.css";
import useFocusTrap from "../../hooks/useFocusTrap";
import { useRef } from "react";
import FocusCover from "../FocusCover/FocusCover";

function Modal({ modalStyle, showModal, setShowModal, children }) {
    const modalRef = useRef(null);
    useFocusTrap(modalRef, showModal, {
        initialFocus: "first",
    });

    function handleClose() {
        setShowModal(false);
    }

    function handleKeyDown(e) {
        if (e.keyCode === 27) {
            setShowModal(false);
        }
    }

    return (
        <>
            <FocusCover
                state={showModal}
                setState={setShowModal}
                background={true}
            />
            <div
                ref={modalRef}
                onKeyDown={handleKeyDown}
                className={[styles.modal, showModal ? styles.show : null].join(
                    " "
                )}
                style={modalStyle}
            >
                <div
                    className={[styles.content_wrapper, "hide-scrollbar"].join(
                        " "
                    )}
                >
                    {children}
                    <div className={styles.close_button_section}>
                        <button
                            className={styles.close_button}
                            onClick={handleClose}
                        >
                            <img src="/images/modal-close-icon.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Modal;
